// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsAccountMaintenanceFeesEnabledPropertyDto
 */
export interface IIsAccountMaintenanceFeesEnabledPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsAccountMaintenanceFeesEnabledPropertyDto
     */
    is_account_maintenance_fees_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsAccountMaintenanceFeesEnabledPropertyDto
     */
    is_account_maintenance_fees_enabled_state?: IIsAccountMaintenanceFeesEnabledPropertyDtoIsAccountMaintenanceFeesEnabledStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsAccountMaintenanceFeesEnabledPropertyDtoIsAccountMaintenanceFeesEnabledStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsAccountMaintenanceFeesEnabledPropertyDto interface.
 */
export function instanceOfIIsAccountMaintenanceFeesEnabledPropertyDto(value: object): value is IIsAccountMaintenanceFeesEnabledPropertyDto {
    return true;
}

export function IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSON(json: any): IIsAccountMaintenanceFeesEnabledPropertyDto {
    return IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSONTyped(json, false);
}

export function IIsAccountMaintenanceFeesEnabledPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsAccountMaintenanceFeesEnabledPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_account_maintenance_fees_enabled': json['is_account_maintenance_fees_enabled'] == null ? undefined : json['is_account_maintenance_fees_enabled'],
        'is_account_maintenance_fees_enabled_state': json['is_account_maintenance_fees_enabled_state'] == null ? undefined : json['is_account_maintenance_fees_enabled_state'],
    };
}

export function IIsAccountMaintenanceFeesEnabledPropertyDtoToJSON(json: any): IIsAccountMaintenanceFeesEnabledPropertyDto {
    return IIsAccountMaintenanceFeesEnabledPropertyDtoToJSONTyped(json, false);
}

export function IIsAccountMaintenanceFeesEnabledPropertyDtoToJSONTyped(value?: IIsAccountMaintenanceFeesEnabledPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_account_maintenance_fees_enabled': value['is_account_maintenance_fees_enabled'],
        'is_account_maintenance_fees_enabled_state': value['is_account_maintenance_fees_enabled_state'],
    };
}

